import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { HelpToolTip } from 'LegacyWeployDesignLanguage/ToolTip';

const TitleContainer = styled.div`
  margin-top: ${props => props.theme.space.double};
  margin-bottom: ${props => props.theme.space.quarter};
  width: 100%;

  ${props => props.dividerVisible && css`
    border-bottom: ${`1px solid ${props.theme.colors.inactiveColor}`};
  `};
`;

const TitleHeader = styled.h5`
  color: ${props => props.theme.colors.text.primary};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 0;
  &:last-child {
    margin-bottom: ${props => props.theme.space.half};
  }
`;

const TitleNameContainer = styled.span`
  vertical-align: middle;
  margin-left: ${props => (props.iconPresent ? props.theme.space.half : 0)};
`;

const HintText = styled.div`
  color: ${props => props.theme.colors.darkerGrey};
  margin-bottom: ${props => props.theme.space.half};

  ${props => props.dividerVisible && css`
    margin-bottom: ${props.theme.space.single};
  `};
`;

const Title = ({
  name,
  icon: Icon,
  renderButton,
  tooltip,
  hintText,
  dividerVisible,
}) => (
  <TitleContainer dividerVisible={dividerVisible}>
    <TitleHeader>
      <span>
        { Icon && <Icon /> }
        <TitleNameContainer iconPresent={!!Icon}>
          {name}
        </TitleNameContainer>
        { !!tooltip && <HelpToolTip text={tooltip} /> }
      </span>
      { renderButton && renderButton() }
    </TitleHeader>
    {!!hintText &&
      <HintText dividerVisible={dividerVisible}>
        {hintText}
      </HintText>
    }
  </TitleContainer>
);

Title.propTypes = {
  name: PropTypes.string.isRequired,
  icon: PropTypes.object,
  renderButton: PropTypes.func,
  tooltip: PropTypes.string,
  hintText: PropTypes.string,
  dividerVisible: PropTypes.bool,
};

Title.defaultProps = {
  icon: null,
  renderButton: null,
  tooltip: '',
  hintText: '',
  dividerVisible: true,
};

export default Title;
